import { FC, RefObject, useEffect, useRef, useState } from 'react';
import { Camelized } from 'humps';
import { Input, Overlay } from '@alf/uikit';
import { CommonLoader } from '@namespace/common';
import {
  getSessionStorageValue,
  SESSION_STORAGE_KEYS
} from '@namespace/helpers';

interface PaymentSystemResultFormProps {
  formData: Camelized<Record<string, unknown>>;
  action: string;
  method?: string;
  target?: string;
}

export const PaymentSystemResultForm: FC<PaymentSystemResultFormProps> = ({
  formData,
  action,
  method = 'POST',
  target = ''
}) => {
  const formRef = useRef<HTMLFormElement>();
  const [isLoading, setIsLoading] = useState(true);
  const prevPathname = getSessionStorageValue(
    SESSION_STORAGE_KEYS.PREV_PATHNAME,
    ''
  );

  useEffect(() => {
    if (formRef.current) {
      formRef.current.submit();
      setIsLoading(false);
      window.history.replaceState(null, '', prevPathname);
    }
  }, []);

  return (
    <form
      ref={formRef as RefObject<HTMLFormElement>}
      action={action}
      target={target}
      method={method}
      acceptCharset="utf-8"
    >
      {target !== '_blank' && isLoading && (
        <Overlay>
          <CommonLoader />
        </Overlay>
      )}
      {Object.keys(formData).map((item, index) => {
        const key = index;
        return (
          <Input
            type="hidden"
            name={item}
            value={`${formData[item]}`}
            key={`resultFormInput-${key}-${item}`}
          />
        );
      })}
    </form>
  );
};
